import React from "react";
import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const CrossHire = Styled(createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 14.9829L4.62499 14.9913C5.38332 14.9913 6.09166 14.6163 6.50833 13.9913L11.8333 6.00796C12.25 5.38296 12.9583 4.99961 13.7167 5.00795L17.5083 5.02463" stroke="#1F2125" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.8333 16.6491L17.4999 14.9824" stroke="#1F2125" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.40835 7.18347L6.50833 5.93347C6.08333 5.34181 5.39999 4.99181 4.67499 5.00015L2.5 5.00849" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.8083 12.8164L11.825 14.1247C12.25 14.6747 12.9167 14.9997 13.6167 14.9997L17.5084 14.9831" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17.4999 5.01628L15.8333 3.34961" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
,
  "CrossHire",
));

export default CrossHire;
